import './all-res.css';

export function ResponsiveSubPage() {
    

    return(
        <div className="container-fluid m-4" >
            <h4 className="gradient-text">Responsive</h4>
            <p className='para'>I will make sure that my websites work properly on most devices</p>
        </div>
    )
}